// Imports
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { t } from "i18next";
import { MdSensors } from "react-icons/md";
import { formatDate } from "util/datelib";
import CircleButton from "widgets/controls/buttons/circle-button";
import Badge from "widgets/shared/badge";

// Define the structure of the JdTableModel
export class AggregatesPageTableModel {
  _id: string;
  data: any;
  timestamp: string;
  snr: string;
  model: string;
  hasData: boolean;
  actions: string;
}
const defineAggregatesTablecolumns = (
  onDataClick?: (info: CellContext<AggregatesPageTableModel, any>) => void
) => {
  // create a column helper for the JdTableModel
  const columnHelper = createColumnHelper<AggregatesPageTableModel>();

  // Define the columns for the JdTable
  const aggregatesPageTablecolumns = [
    // Description column
    columnHelper.accessor("timestamp", {
      enableSorting: false,
      header: () => <span className="">{t("table.header.timestamp")}</span>,
      cell: (info) => (
        <span className="">{formatDate(info.getValue(), "lastcomms")}</span>
      ),
      meta: { rowClick: false },
    }),

    columnHelper.accessor("data", {
      enableSorting: false,
      header: () => <span className="">{t("table.header.data")}</span>,
      cell: (info) => (
        <span className="">{JSON.stringify(info.getValue())}</span>
      ),
      meta: { rowClick: false },
    }),

    // Status column
    columnHelper.accessor("hasData", {
      enableSorting: false,
      header: () => <span className="">{t("table.header.has.data")}</span>,
      cell: (info) => (
        <span className="">
          {
            <Badge
              label={info.getValue() ? t("common.true") : t("common.false")}
              color={info.getValue() ? "green" : "red"}
            />
          }
        </span>
      ),
      meta: { rowClick: false },
    }),

    // Actions column
    columnHelper.accessor("actions", {
      enableSorting: false,
      header: () => <span className="">{t("table.header.actions")}</span>,
      cell: (info) => {
        return (
          <div className="flex flex-row">
            <CircleButton
              icon={MdSensors}
              size="sm"
              variant="ghost"
              onClick={() => {
                onDataClick?.(info);
              }}
              tooltip={t("tooltip.data")}
              tooltipPlacement="bottom"
            />
          </div>
        );
      },
    }),
  ];

  return aggregatesPageTablecolumns;
};

export default defineAggregatesTablecolumns;
